<header>
  <section class="title-container">
    <h1>Select a {{theme.fpLabel}}</h1>
    <h2>
      <icon name="community"></icon>
      {{communityName}}
    </h2>
  </section>

  @if (isWithinModal) {
    <button class="close-btn" (click)="dialogRef.close()">
      <icon name="x"></icon>
    </button>
  }
</header>

<section class="cards-container">
  @if (showLotFilter && allNeighborhoodsWithLots.length) {
    <p class="label">Filter by {{theme.lotLabel}}</p>
    <mat-select panelClass="hc-styles lot-select" [(value)]="dropdownSelectedLot" aria-label="Filter by lot"
      (selectionChange)="handleLotSelectChange($event.value)" placeholder="All {{theme.lotLabel}}s">
      <mat-select-trigger>
        @if (+currentBuild.Lot?.EntityId === dropdownSelectedLot?.LotId) {
          <div class="bubble">
            <icon name="check"></icon>
          </div>
        }
        {{dropdownSelectedLot?.Title}}
      </mat-select-trigger>
      <mat-option>All {{theme.lotLabel}}s</mat-option>
      @for (hood of allNeighborhoodsWithLots; track hood) {
        <mat-optgroup [label]="hood.DisplayName">
          @for (lot of hood.Lots; track lot) {
            <mat-option [value]="lot">
              @if (+currentBuild.Lot?.EntityId === lot.LotId) {
                <div class="bubble">
                  <icon name="check"></icon>
                </div>
              }
              {{$any(lot).Title}}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
  }

  @for (floorplan of filteredFloorplansAndIH; track trackByFloorPlanId(index, floorplan); let index = $index) {
    <div class="col">
      <hc-fp-card [effectiveFP]="floorplan" [indexInList]="index + 1" [listTotal]="filteredFloorplansAndIH.length" [build]="currentBuild"
      (floorplanSelect)="handleFloorplanSelect(floorplan)" (floorplanChange)="handleFloorplanChange()"></hc-fp-card>
    </div>
  }
</section>